import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { WebNotificationPermission, WebNotificationStatus } from '@/services/notificationsWeb';

import { storageService } from '../../services/storage';

interface NotificationsState {
  permission: WebNotificationPermission | null;
  status: WebNotificationStatus;
  switchChange: boolean;
}

const initialState: NotificationsState = {
  permission: null,
  status: WebNotificationStatus.NOT_ESTABLISHED,
  switchChange: false,
};

export const notificationsSlice = createSlice({
  name: 'notifications',
  initialState,
  reducers: {
    browserPermissions: (state, action: PayloadAction<WebNotificationPermission>) => {
      localStorage.setItem('browserNotifications', action.payload);
      state.permission = action.payload;
    },
    updateNotificationStatus: (state, action: PayloadAction<WebNotificationStatus>) => {
      localStorage.setItem('webNotificationStatus', action.payload.toString());
      state.status = action.payload;
    },
    changeNotificationsSwitch: (state, action: PayloadAction<boolean | null>) => {
      localStorage.setItem('notificationsSwitch', action.payload!.toString());
      state.switchChange = action.payload!;
    },
  },
});

export const { browserPermissions, updateNotificationStatus, changeNotificationsSwitch } = notificationsSlice.actions;

export default notificationsSlice.reducer;
